import * as React from 'react';
import { BaseButton, ButtonLook, ButtonProps } from './base_button';

// A button that skips the usual button styling.
// Specifically, it doesn't include the .baseButton styles in button.module.css
// Needed if you want to use the "busy" behavior of buttons
export const PlainButton = (props: ButtonProps) => (
  <BaseButton look={ButtonLook.PLAIN} {...props}/>
);
